module.exports = __webpack_public_path__ + "img/repair.5d192c1b.jpg";